import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from 'ui-library';
import QuestionnaireQuestion from '../QuestionnaireQuestion';
import './QuestionnaireGroup.css';

const QUESTION_ID_FOR_INFORMATION = 240;

interface Answer {
    Id: number;
    Text: number | string;
}

interface Question {
    Id: number;
    Text: string;
    Title?: string;
    Layout?: string;
    Answers?: Answer[];
    Disabled?: boolean;
    [key: string]: any; // For the rest of the question properties
}

interface Step {
    Id: number | string;
    Questions: Question[];
}

interface QuestionnaireData {
    Name?: string;
    Description?: string;
    Steps?: Step[];
}

interface QuestionnaireGroupProps {
    data?: QuestionnaireData;
    value?: Record<number, number | number[]>;
    errors?: Record<number, string>;
    onChange?: (event: any) => void; // Replace 'any' with your specific event type if known
    title?: string;
    defaultValue?: number[] | undefined;
    disableDefaultValue?: boolean;
    radioRenderComponent?: (args: {
        val?: number | string | number[];
        desc: string;
        error?: string;
        options: { value: number | string; label: string | number; disabled: boolean; name: number | string }[];
        onChange: (val: any) => void;
    }) => React.ReactNode;
}

const QuestionnaireGroup: React.FC<QuestionnaireGroupProps> = ({
    data,
    value = {},
    errors = {},
    onChange = () => {},
    title = '',
    defaultValue = undefined,
    disableDefaultValue = false,
    radioRenderComponent,
}) => {
    const { t } = useTranslation();

    return (
        <div className="questionnaire-group">
            <Title type={2}>{title}</Title>
            <div className="questionnaire-group-content">
                {(data?.Steps || []).map((step) => (
                    <div className="step-content" key={step?.Id}>
                        {(step?.Questions || []).map((question) => (
                            <React.Fragment key={question.Id}>
                                {question?.Id === QUESTION_ID_FOR_INFORMATION && (
                                    <Title
                                        type={3}
                                        className="quality-check-disclaimer-text"
                                    >
                                        {t('QualityCheck.DisclaimerText')}
                                    </Title>
                                )}
                                <QuestionnaireQuestion
                                    data={{
                                        ...question,
                                        GroupDescription: data?.Description,
                                    }}
                                    value={value[question.Id]}
                                    error={errors[question.Id]}
                                    onChange={onChange}
                                    defaultValue={defaultValue}
                                    disableDefaultValue={disableDefaultValue}
                                    radioRenderComponent={radioRenderComponent}
                                    disabled={question.Disabled ? true : undefined}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionnaireGroup;
